import styled from "styled-components/macro";
import { Modal } from "antd";

import { typography } from "../../../utils/styledComponents/typography";
import { colors } from "src/theme/colors";

export const StyledModal = styled(Modal)`
  &.ant-modal {
    /* No footer rules here. The fina-dialog chrome already draws the band —
       sunk, ruled off, right-aligned with its own gap — and these were
       fighting it to lay out a column that should never have been one. */
    ${typography.CustomText("1em")}
    .ant-modal-body {
      padding: 10px;
      padding-top: 0px;
    }
    .ant-modal-header {
      border-bottom: 0px;
      .ant-modal-title {
        text-align: center;
      }
    }
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  /* Was rgba(220, 53, 69, 0.2) — a red mixed by hand, and not one of the
     product's. The error tint is a token. */
  background-color: ${colors.error[50]};
  margin-top: 8px;
  margin-bottom: 16px;
`;

export const Title = styled.span`
  ${typography.CustomText("18px")}
  font-weight: 600;
  letter-spacing: -0.015em;
  color: ${colors.gray[900]};
`;

export const SubTitle = styled.span`
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
  /* opacity 0.5 dimmed the glyphs rather than colouring them, which is how
     a sentence ends up at a contrast nobody chose. */
  color: ${colors.gray[600]};
`;

export const Frame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px 8px 4px;
`;
